// extracted by mini-css-extract-plugin
export var breadcrumbs = "SiteLayout-module--breadcrumbs---5npx";
export var component = "SiteLayout-module--component--ZMX5p";
export var content = "SiteLayout-module--content--q-75F";
export var main = "SiteLayout-module--main--+oIzp";